import { Button, Checkbox, Input, Spin, Tag } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { FaChevronRight } from "react-icons/fa";
import { useMap } from "react-leaflet";
import { applyFilters } from "../../Utils/filter"; // Import utility function
import { fetchTreeData } from "../GISPortel/data";
import "./FilterPanel.css";
import L from "leaflet";


const FilterPanel = ({ data, onApplyFilters, onResetFilters, focusOnLocation }) => {
  const [treeNames, setTreeNames] = useState([]);
  const [showFilterPanel, setShowFilterPanel] = useState(true);
  const [trees, setTrees] = useState([]); 
  const [locations, setLocations] = useState([]);
  const [selectAllTree, setSelectAllTree] = useState(false);
  const [selectAllLocation, setSelectAllLocation] = useState(false);
  const [selectedTreeNames, setSelectedTreeNames] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedSurveyTypes, setSelectedSurveyTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activePanel, setActivePanel] = useState(null); // For managing active panel (Tree/Location)
  const panelRef = useRef(null); // Ref for the filter panel
  const [searchQueryLocation, setSearchQueryLocation] = useState("");
  const [searchQueryTree, setSearchQueryTree] = useState("");
  const token = sessionStorage.getItem("token") || localStorage.getItem("token");
  const surveyTypes = ["in_situ", "transplant", "compensatory"];
  const defaultColors = ["#B6F092", "#FFA1E3", "#FA9658"];
  const [filteredTree, setFilteredTrees] = useState(trees);
  const [filteredLocations, setFilteredLocations] = useState(locations);
  const map = useMap(); // Get access to the Leaflet map instance
  



  useEffect(() => {
    if (data) {
      setTreeNames([...new Set(data.map(item => item.properties.tree_name))]);
      setLocations([...new Set(data.map(item => item.properties.station_name))]);
    }
  }, [data]);
  

  // Add event listener for outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        panelRef.current && 
        !panelRef.current.contains(e.target) // Check if click is outside main panel
      ) {
        setActivePanel(null); // Close active panel
      }
    };
  
    document.addEventListener("click", handleOutsideClick);
  
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);
  

  // Fetch data for tree names and locations

  useEffect(() => {
    const loadTrees = async () => {
      setLoading(true);
      const data = await fetchTreeData();  // Fetch tree data
      setTrees(data);  // Store the full tree data
      setFilteredTrees(data);  // Initially set filtered trees to all trees
      setLoading(false);
    };
    loadTrees();
  }, []);


  const handleSelectAll = (panelType) => {
    if (panelType === "Tree") {
      setSelectAllTree((prev) => !prev);
      setSelectedTreeNames(selectAllTree ? [] : treeNames);
    } else if (panelType === "Location") {
      setSelectAllLocation((prev) => !prev);
      setSelectedLocations(selectAllLocation ? [] : locations);
    }
  };

 
  const filteredTreeNames = treeNames.filter((name) =>
    name.toLowerCase().includes(searchQueryTree.toLowerCase())
  );
  
  

    // Handle selection change for tree names and locations
  
    const handleSelectionChange = (type, selectedOptions) => {
      if (type === "Tree") {
        setSelectedTreeNames(selectedOptions);
    
        // Update filtered trees based on search query
        setFilteredTrees(
          treeNames.filter((name) =>
            name.toLowerCase().includes(searchQueryTree.toLowerCase())
          )
        );
      } else if (type === "Location") {
        setSelectedLocations(selectedOptions);
    
        // Update filtered locations based on search query
        setFilteredLocations(
          locations.filter((loc) =>
            loc.toLowerCase().includes(searchQueryLocation.toLowerCase())
          )
        );
      }
    };
    useEffect(() => {
      setFilteredLocations(
        locations.filter((loc) =>
          loc?.toLowerCase().includes(searchQueryLocation.toLowerCase())
        )
      );
    }, [searchQueryLocation, locations]); // Re-run when search or locations update
    
    

    const handleMouseEnter = () => {
      map.scrollWheelZoom.disable(); // Disable map zoom when hovering over list
    };

    const handleMouseLeave = () => {
      map.scrollWheelZoom.enable(); // Enable map zoom when leaving list
    };
    const closeFilterPanel = () => {
      // Option 1: if you're toggling visibility using state
      setShowFilterPanel(false);
    
      // Option 2: if you're manipulating DOM directly
      if (panelRef.current) {
        panelRef.current.style.display = 'none';
      }
    };
    

    
    


    const handleSurveyTypeChipClick = (type) => {
      // Toggle the survey type selection
      setSelectedSurveyTypes((prev) =>
        prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
      );
    };

  // const handleSurveyTypeChipClick = (type) => {
  //   setSelectedSurveyTypes((prev) =>
  //     prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
  //   );
  // };
  

  const handleApplyFilters = () => {
    const filters = {
      treeNames: selectedTreeNames,
      locations: selectedLocations,
      surveyTypes: selectedSurveyTypes,
    };
  
    const filteredData = applyFilters(data, filters);
    onApplyFilters(filteredData);
  
    if (focusOnLocation) {
      focusOnLocation(filteredData); // Zoom to the filtered data
    }
  
    // Clear search queries
    setSearchQueryTree("");
    setSearchQueryLocation("");
  
    // Refresh all options
    setFilteredTrees(treeNames);
    setFilteredLocations(locations);
  
    setActivePanel(null); // Close the panel
  };
  
  
  
  
  
  const handleResetFilters = () => {
    setSelectedTreeNames([]);
    setSelectedLocations([]);
    setSelectedSurveyTypes([]);
    onResetFilters(data); // Reset to original data
    setActivePanel(null); // Close panels
  };
  

  
  
  const togglePanel = (panelType) => {
    setActivePanel((prev) => (prev === panelType ? null : panelType));
  
    if (panelType === "Tree") {
      setFilteredTrees(
        treeNames.filter((name) =>
          name.toLowerCase().includes(searchQueryTree.toLowerCase())
        )
      );
    } else if (panelType === "Location") {
      setFilteredLocations(
        locations.filter((loc) =>
          loc.toLowerCase().includes(searchQueryLocation.toLowerCase())
        )
      );
    }
  };
  


  const handleSearchQueryLocation = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQueryLocation(query);
  
    // Ensure locations list updates properly
    const filtered = locations.filter((loc) =>
      loc?.toLowerCase().includes(query)
    );
    setFilteredLocations(filtered);
  };
  
    const handleSearchQueryTree = (e) => {
      const query = e.target.value.toLowerCase();
      setSearchQueryTree(query);
    
      // Dynamically update the filtered list based on the query
      setFilteredTrees(
        treeNames.filter((name) => name.toLowerCase().includes(query))
      );
    };

    const handleTouchStart = () => {
      map.scrollWheelZoom.disable(); // Disable map zoom on touch start
    };
    
    const handleTouchEnd = () => {
      map.scrollWheelZoom.enable(); // Re-enable map zoom on touch end
    };
  
    const disableMapInteractions = () => {
      map.dragging.disable();       // Disable panning
      map.touchZoom.disable();      // Disable touch zoom
      map.doubleClickZoom.disable(); // Disable double-tap zoom
      map.scrollWheelZoom.disable(); // Disable scroll zoom
      map.boxZoom.disable();        // Disable box zoom
      map.tap?.disable();           // Disable tap (if available)
    };
  
    // Enable all map interactions
    const enableMapInteractions = () => {
      map.dragging.enable();
      map.touchZoom.enable();
      map.doubleClickZoom.enable();
      map.scrollWheelZoom.enable();
      map.boxZoom.enable();
      map.tap?.enable();
    };
  
    // Prevent event propagation for touchmove
    const handleTouchMove = (e) => {
      e.stopPropagation(); // Stop touchmove from reaching the map
    };
  

  
  // Button label for selected locations
  const selectedLocationLabel = selectedLocations.length
    ? selectedLocations.join(", ")
    : "Select Location";

  // Button label for selected tree names
  const selectedTreeNameLabel = selectedTreeNames.length
    ? selectedTreeNames.join(", ")
    : "Select Tree Name";

    return (
      <div className="filter-panel-container" ref={panelRef}>
        {/* style={{ display: "flex", position: "relative",bottom:"37px", }} */}
        {/* Main Filter Panel */}
        {showFilterPanel && (
        <div className="main-filter-panel" >
          <Button
            type="text"
            onClick={() => setShowFilterPanel(false)}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              zIndex: 10,
              fontSize: "16px",
              fontWeight: "bold",
              color: "#999",
              border: "none",
            }}
          >
            ✕
          </Button>
          <p style={{  color:"black",fontSize:"15px",marginTop:"0px", fontFamily: "'Poppins-thin', sans-serif", paddingTop:"0px" ,marginBottom:"2px",textAlign: "left" ,fontFamily: "'Poppins-thin', sans-serif",}}>Filter By</p>
          {loading ? (
            <Spin />
          ) : (
            <div>
              {/* Tree Name Filter */}
              <div style={{ marginBottom: "0px" , marginTop:"0px", paddingTop:"0px" }}>
                <p style={{ fontSize:"12px",marginTop:"1px", paddingTop:"2px" ,paddingBottom:"0px",fontFamily: "'Poppins-thin', sans-serif",marginBottom:"0px",}}>Tree Name</p>
                <Button
                  onClick={() => togglePanel("Tree")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    marginTop:"0px", paddingTop:"10px" ,fontFamily: "'Poppins-thin', sans-serif",
                  }}
                >
                  <span
                    style={{
                      paddingBottom:"10px",
                      paddingLeft:"10px",
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      display: 'inline-block',
                      maxWidth: 'calc(100% - 40px)', // Adjust as needed to fit within the button width
                    }}
                  >
                    {selectedTreeNameLabel}
                  </span>
                  <FaChevronRight
                    style={{
                      transform: activePanel === "Tree" ? "rotate(90deg)" : "rotate(0deg)",
                      transition: "transform 0.3s",
                      paddingBottom:"10px",
                      paddingRight:"10px",
                    }}
                  />
                </Button>
              </div>
    
              {/* Location Filter */}
              <div style={{ marginBottom: "10px" }}>
              <p style={{  fontSize:"12px",paddingTop:"2px",marginTop:"1px" ,paddingBottom:"0px",fontFamily: "'Poppins-thin', sans-serif",marginBottom:"0px",}}>Location</p>
                <Button
                  onClick={() => togglePanel("Location")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    marginTop:"0px", paddingTop:"10px" ,fontFamily: "'Poppins-thin', sans-serif",
                  }}
                >
                  <span
                    style={{
                      overflow: 'hidden',
                      paddingBottom:"10px",
                      paddingLeft:"10px",
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      display: 'inline-block',
                      maxWidth: 'calc(100% - 40px)', // Adjust as needed to fit within the button width
                    }}
                  >
                    {selectedLocationLabel}
                  </span>
                  <FaChevronRight
                    style={{
                      transform: activePanel === "Location" ? "rotate(90deg)" : "rotate(0deg)",
                      transition: "transform 0.3s",
                      paddingBottom:"10px",
                      paddingRight:"10px",
                    }}
                  />
                </Button>
              </div>
    
              {/* Survey Type Filter */}
              <div style={{ marginBottom: "10px" }}>
              <p style={{ marginTop:"1px",fontSize:"12px", paddingTop:"2px" ,paddingBottom:"0px",fontFamily: "'Poppins-thin', sans-serif", marginBottom:"0px",}}>Survey Type</p>
                {surveyTypes.map((type, index) => (
                  <Tag
                    key={type}
                    color={selectedSurveyTypes.includes(type) ?defaultColors[index]  : "gray"}
                    onClick={() => handleSurveyTypeChipClick(type)} style={{ cursor: "pointer", margin: "2px",fontSize:"12px", fontFamily: "'Poppins-thin', sans-serif", }}>
                    {type}
                  </Tag>
                ))}
              </div>
    
              {/* Submit and Reset Buttons */}
              <Button
                onClick={handleApplyFilters}
                style={{
                  width: "100%",
                  backgroundColor: "#00917D",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  fontFamily: "'Poppins-thin', sans-serif",
                  paddingTop:"5px",
                  marginTop:"0px",
                }}
              >
                Apply
              </Button>
              <Button
                onClick={handleResetFilters}
                style={{
                  width: "100%",
                  backgroundColor: "black",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  marginTop: "10px",
                  fontFamily: "'Poppins-thin', sans-serif",
                }}
              >
                Reset Filters
              </Button>
            </div>
          )}
        </div>
        )}
    
        {/* Tree Names Panel */}
        {activePanel === "Tree" && (
          <div className="sub-panel"
            // style={{
            //   position: "absolute",
            //   top: "0px",
            //   left: "350px",
            //   zIndex: 1000,
            //   backgroundColor: "rgba(255, 255, 255, 0.8)",
            //   borderRadius: "4px",
            //   padding: "15px",
            //   boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            //   border: "1px solid #ccc",
            //   width: "250px",
            //   height: "300px", // Fixed height for the panel
            //   overflow: "hidden", // Prevent content from overflowing the panel
            //   fontFamily: "'Poppins-thin', sans-serif",
            // }}
          >
            <p  style={{padding:"5px",margin:"5px",fontFamily: "'Poppins-thin', sans-serif",}}>Trees</p> {/* Added "Trees" title */}
            <Input
              placeholder="Search Tree"
              value={searchQueryTree}
              onChange={(e) => setSearchQueryTree(e.target.value)}
              style={{ marginBottom: "10px", width: "100%",fontFamily: "'Poppins-thin', sans-serif", }}
            />
            
            <Checkbox
              checked={selectAllTree}
              onChange={() => handleSelectAll("Tree")}
              style={{ marginBottom: "10px" ,fontFamily: "'Poppins-thin', sans-serif",}}
            >
              Select All
            </Checkbox>
            <div className="scrollable-content"
              style={{
                maxHeight: "150px", // Set maximum height for the scrollable area
                overflowY: "auto", // Allow vertical scrolling
                fontFamily: "'Poppins-thin', sans-serif",
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onTouchStart={disableMapInteractions} // Disable map on touch start
              onTouchEnd={enableMapInteractions}   // Re-enable map on touch end
              onTouchMove={handleTouchMove}        // Prevent map panning
            >
               <Checkbox.Group
                  options={filteredTreeNames}
                  value={selectedTreeNames}
                  onChange={(e) => handleSelectionChange("Tree", e)}
                  style={{ display: "flex", flexDirection: "column" ,fontFamily: "'Poppins-thin', sans-serif",}}
                />
            </div>
          </div>
        )}
    
        {/* Locations Panel */}
        {activePanel === "Location" && (
          <div className="sub-panel"
            // style={{
            //   position: "absolute",
            //   top: "0px",
            //   left: "350px",
            //   zIndex: 1000,
            //   backgroundColor: "rgba(255, 255, 255, 0.8)",
            //   borderRadius: "4px",
            //   padding: "15px",
            //   boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            //   border: "1px solid #ccc",
            //   width: "250px",
            //   height: "300px", // Fixed height for the panel
            //   overflow: "hidden", // Prevent content from overflowing the panel
            //   fontFamily: "'Poppins-thin', sans-serif",
            // }}
          >
            <p  style={{padding:"5px",margin:"5px",}}>Locations</p> {/* Added "Locations" title */}
            <Input
                placeholder="Search Location"
                value={searchQueryLocation}
                onChange={handleSearchQueryLocation}
                style={{ marginBottom: "10px", width: "100%" ,fontFamily: "'Poppins-thin', sans-serif",}}
              />
            <Checkbox
              checked={selectAllLocation}
              onChange={() => handleSelectAll("Location")}
              style={{ marginBottom: "10px" ,fontFamily: "'Poppins-thin', sans-serif",}}
            >
              Select All
            </Checkbox>
            <div className="scrollable-content"
              // style={{
              //   maxHeight: "150px", // Set maximum height for the scrollable area
              //   overflowY: "auto", // Allow vertical scrolling
              //   fontFamily: "'Poppins-thin', sans-serif",
              // }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onTouchStart={disableMapInteractions} // Disable map on touch start
              onTouchEnd={enableMapInteractions}   // Re-enable map on touch end
              onTouchMove={handleTouchMove}   
              >
               <Checkbox.Group
                  options={filteredLocations}  // Use filtered locations here
                  value={selectedLocations}
                  onChange={setSelectedLocations}
                  style={{ display: "flex", flexDirection: "column" ,fontFamily: "'Poppins-thin', sans-serif",}}
                />

            </div>
          </div>
        )}
      </div>
    );
    
};

export default FilterPanel;
